import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { CoreState } from '@core/store/core.reducers';
import { Store } from '@ngrx/store';
import { ISelectItem } from '@shared/models/interfaces/select-item.interface';
import { debounceTime, Observable, Subscription } from 'rxjs';
import { filter, tap, withLatestFrom } from 'rxjs/operators';
import { Revisione53DatiBusinessSelectors } from '../../../features/revisione53/core/store/selectors/dati-business.selectors';
import { Revisione53CoreSelectors } from '../../../features/revisione53/core/store/selectors/core.selectors';
import { sortByFieldAlphabeticallyOperator } from '@shared/operators/sort-by-field-alphabetically.operator';
import { mapToSelectItems } from '@shared/operators/map-to-select-items.operator';
import { get } from 'lodash-es';
import { Utilities } from '@core/helpers/utilities';

@Component({
    selector: 'provincia-comune[form]',
    templateUrl: './provincia-comune.component.html',
    styleUrls: ['./provincia-comune.component.scss'],
})
export class ProvinciaComuneComponent implements OnInit, OnDestroy {
    @Input() form: FormGroup;
    @Input() provinciaName: string;
    @Input() comuneName: string;

    itemsProvince$: Observable<ISelectItem[]>;
    itemsComuni$: Observable<ISelectItem[]>;

    private sub: Subscription = new Subscription();

    constructor(private store: Store<CoreState>) {}

    ngOnInit(): void {
        const provinciaControl: AbstractControl = this.form.get(this.provinciaName);
        const comuneControl: AbstractControl = this.form.get(this.comuneName);

        if (!provinciaControl.value) {
            comuneControl.disable();
        }

        this.itemsProvince$ = this.store.select(Revisione53DatiBusinessSelectors.getProvince).pipe(
            mapToSelectItems((provincia) => `${provincia.Nome} (${provincia.sigla})`, 'Id_provincia'),
            sortByFieldAlphabeticallyOperator('key')
        );

        this.sub.add(
            provinciaControl.valueChanges
                .pipe(
                    debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME),
                    tap((idProvincia) => {
                        if (comuneControl.disabled) {
                            comuneControl.enable();
                        }
                        this.addComuni(idProvincia);
                    }),
                    withLatestFrom(this.store.select(Revisione53CoreSelectors.getMyVerbale)),
                    filter(([value, myVerbale]) => value !== get(myVerbale, this.provinciaName))
                )
                .subscribe(() => comuneControl.setValue(''))
        );

        if (provinciaControl.value) {
            this.addComuni(provinciaControl.value);
        }
    }

    private addComuni(idProvincia: string): void {
        this.itemsComuni$ = this.store
            .select(Revisione53DatiBusinessSelectors.getComuni(idProvincia))
            .pipe(mapToSelectItems('Nome_comune', 'cod_comune'), sortByFieldAlphabeticallyOperator('key'));
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
}
